// Vidalga PDP — wires the visual pack selector to the theme's REAL native
// quantity input, so the cart/checkout always reflects what is shown here.
// No price is invented or overridden client-side; only the real quantity field
// of the native product form is updated.
(function () {
  function init(root) {
    var productDetails = root.closest('.product-details') || document.querySelector('.product-details');
    if (!productDetails) return;

    var form = productDetails.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var packButtons = Array.prototype.slice.call(root.querySelectorAll('.pdp-pack'));
    if (!qtyInput || packButtons.length === 0) return;

    function selectPack(btn) {
      packButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      var qty = parseInt(btn.getAttribute('data-pack-quantity'), 10) || 1;
      qtyInput.value = qty;
      // Fire the events the native quantity component listens for so its own
      // state (and any price/label it manages) updates correctly.
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('blur', { bubbles: true }));
    }

    packButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectPack(btn);
      });
    });

    var defaultBtn = packButtons.filter(function (b) {
      return b.getAttribute('data-pack-default') === 'true';
    })[0] || packButtons[0];
    if (defaultBtn) selectPack(defaultBtn);
  }

  document.querySelectorAll('[data-pdp-pack-selector]').forEach(init);

  document.addEventListener('shopify:section:load', function (evt) {
    evt.target.querySelectorAll('[data-pdp-pack-selector]').forEach(init);
  });
})();
